import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";
const verIcon = require("assets/img/icons/ver.png");
const eliminarIcon = require("assets/img/icons/borrar.png");

// Cada fila es un cierre y se abre en su propia pantalla para ver lo que quedó
// registrado en él. Solo el último cierre de cada producto padre se puede
// eliminar
export const CierresMensualesProduccionTable = ({ hook }) => {
    return (
        <div className="new-table-wrapper my-3">
            <table className="table-striped-v2">
                <thead>
                    <tr>
                        <th>Fecha de corte</th>
                        <th>Producto padre</th>
                        <th>Semanas</th>
                        <th>Periodos de almacén</th>
                        <th>Registrado por</th>
                        <th>Fecha de registro</th>
                        <th className="text-center">Acciones</th>
                    </tr>
                </thead>

                <tbody>
                    {hook.cierres.length === 0 && (
                        <tr>
                            <td className="text-center" colSpan={7}>
                                No hay cierres registrados
                            </td>
                        </tr>
                    )}

                    {hook.cierres.map((cierre) => (
                        <tr key={cierre.id} className="text-center">
                            <td className="text-nowrap">
                                {moment(cierre.fecha_corte).format(
                                    "DD/MM/YYYY",
                                )}
                            </td>
                            <td className="text-nowrap">
                                {cierre.padre_producto_terminado_nombre}
                            </td>
                            <td className="text-center">
                                {cierre.total_semanas}
                            </td>
                            <td className="text-center">
                                {cierre.total_periodos}
                            </td>
                            <td className="text-nowrap">
                                {cierre.nombre_usuario}
                            </td>
                            <td className="text-nowrap">
                                {moment(cierre.fecha_creacion).format(
                                    "DD/MM/YYYY HH:mm",
                                )}
                            </td>
                            <td className="text-center text-nowrap">
                                <Link
                                    to={`/produccion-v2/cierres-mensuales/detalle-cierre/${cierre.id}`}
                                >
                                    <img
                                        src={verIcon}
                                        alt="Ver detalle"
                                        title="Ver detalle"
                                        className="action_img"
                                    />
                                </Link>

                                {cierre.es_ultimo_cierre && (
                                    <img
                                        src={eliminarIcon}
                                        alt="Eliminar"
                                        title="Eliminar cierre"
                                        className="action_img ml-2"
                                        onClick={() =>
                                            hook.EliminarCierre(cierre)
                                        }
                                    />
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
